export enum discountPaths {
  DISCOUNT = '',
  DISCOUNT_SETTINGS = '/discount-settings',
  TERM_DISCOUNT = '/term-discount'
}
